import Theme from '@/const/modules/theme';
import Roles from '@/const/modules/roles';
import Game from '@/const/modules/game';

export default { 
    ...Theme,
    ...Roles,
    ...Game
};